<template>
  <v-btn
    small
    color="primary"
    dark
    class="elevation-0 text-right"
    @click.stop="setiniciar(false)"
  >
    <v-icon left> mdi-plus </v-icon>
    {{ mytext }}
  </v-btn>
</template>

<script>
export default {
  methods: {},
  props: {
    iniciacar: Boolean,
    setiniciar: Function,
    mytext: String,
  },
  data() {
    return {};
  },
};
</script>
